export class ProtectedEquipmentOrgTreeNode {
  orgTreeNodeId: string;
  name: string;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.name = data.name;
  }
}
